import { ChakraFlex, FAIconName, FireflyButton, Text } from '@equip.health/ui';
import { AnalyticsEvent } from '~/analytics';
import { AISummaryEvents } from '~/analytics/aiSummaryEvents';
import AiBoltIcon from '~/assets/svg/AiBoltIcon';
import { PatientNoteAiSummaryGradientBannerContainer } from '~/components/maud/patients/note/aiSummaryBanner/PatientNoteAiSummaryGradientBannerContainer';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

type Props = {
  onAddToNoteClick: () => void;
};
export const PatientNoteAiSummaryAvailableBanner = ({
  onAddToNoteClick,
}: Props) => {
  const { trackEvent } = useAnalytics();
  const sendAnalyticsEvent = (analyticsEvent: AnalyticsEvent) => {
    trackEvent(analyticsEvent, {
      Source: AnalyticsSourceValues.SESSION_GUIDE,
    });
  };
  return (
    <PatientNoteAiSummaryGradientBannerContainer>
      <ChakraFlex alignItems="center">
        <AiBoltIcon />
        <Text marginLeft="7px" variant="body">
          An AI summary is available. Please add to the note and review.
        </Text>
      </ChakraFlex>
      <FireflyButton
        id="patient-note-ai-summary-available-banner-add"
        leftIcon={FAIconName.plusRegular}
        onClick={() => {
          onAddToNoteClick();
          sendAnalyticsEvent(AISummaryEvents.aiSummaryAddedToNote);
        }}
        variant="tertiary"
      >
        Add to note
      </FireflyButton>
    </PatientNoteAiSummaryGradientBannerContainer>
  );
};
